import { type AppConfigContextType } from 'components/context/AppConfigContext'

export function getSupportLink (environment: AppConfigContextType['environment']): string {
  if (environment === 'production') {
    return 'https://thatch.com/onboarding/get-support'
  }
  return 'https://staging.thatch.com/onboarding/get-support'
}
